import * as React from 'react'

import { Button, spacing } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'
import { ScheduleTourModal_school, ScheduleTourModal_tourOpenings } from '../../common/gql'
import ProgressBar from '../../common/ProgressBar'
import SchoolSummary from '../../common/SchoolSummary'
import { Container } from './OpeningSelection.styles'
import Selector from './Selector'

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-OPENING-SELECTION`

interface IProps {
  openings: ScheduleTourModal_tourOpenings[]
  selectedOpening: ScheduleTourModal_tourOpenings | null
  school: ScheduleTourModal_school
  onSelectOpening: (opening: ScheduleTourModal_tourOpenings | null) => void
  onComplete: () => void
}

interface IValidation {
  selector?: string
}

export default function OpeningSelection(props: IProps) {
  const { openings, selectedOpening, school, onSelectOpening, onComplete } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const [validationHints, setValidationHints] = React.useState<IValidation>({})

  return (
    <Container>
      <SchoolSummary school={school} />
      <div css={{ marginTop: spacing.majorScale(1) }}>
        <ProgressBar progress={70} />
      </div>

      <div css={{ marginTop: spacing.majorScale(3) }}>
        <Selector
          openings={openings}
          selectedOpening={selectedOpening}
          validationHint={validationHints.selector}
          onSelect={onSelectOpening}
        />
      </div>

      <Button
        css={{ marginTop: spacing.majorScale(5) }}
        full
        onClick={() => {
          if (selectedOpening) {
            onComplete()
          } else {
            setValidationHints({ selector: t(`${PRE}-VALIDATION`) })
          }
        }}
      >
        {t(`${PRE}-BUTTON`)}
      </Button>
    </Container>
  )
}
